export const NEW_PRODUCT_SUB_CATEGORY = "NEW_PRODUCT_SUB_CATEGORY";
export const ALL_PRODUCT_SUB_CATEGORY = "ALL_PRODUCT_SUB_CATEGORY";
export const PRODUCT_SUB_CATEGORY_BY_ID = "PRODUCT_SUB_CATEGORY_BY_ID";
export const PRODUCT_SUB_CATEGORY_BY_CATEGORY_ID = "PRODUCT_SUB_CATEGORY_BY_CATEGORY_ID";
export const UPDATE_PRODUCT_SUB_CATEGORY = "UPDATE_PRODUCT_SUB_CATEGORY";
export const DELETE_PRODUCT_SUB_CATEGORY = "DELETE_PRODUCT_SUB_CATEGORY";
export const UPLOAD_PRODUCT_SUB_CATEGORY_IMG = "UPLOAD_PRODUCT_SUB_CATEGORY_IMG";
